/**
 * MessageRolePill
 * Small pill that appears over a selected chat message bubble
 * indicating to the user whether the message they selected is theirs
 * (operator) or from the contact (customer). Removes ambiguity when
 * the AI Workspace will use the selection as context.
 */
import React from 'react';
import { User2, MessageCircle } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { getWorkspaceColors } from './styles';

const MessageRolePill = ({ role, label, side = 'left' }) => {
  const { colors, theme } = useTheme();
  const wc = getWorkspaceColors(colors, theme === 'dark');

  const isOperator = role === 'operator';
  const accent = isOperator ? wc.roleOperator : wc.roleCustomer;
  const Icon = isOperator ? User2 : MessageCircle;

  const styles = {
    pill: {
      position: 'absolute',
      top: -10,
      [side === 'right' ? 'right' : 'left']: 8,
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      padding: '2px 8px',
      borderRadius: 999,
      backgroundColor: accent,
      color: '#fff',
      fontSize: 10,
      fontWeight: 700,
      letterSpacing: 0.3,
      boxShadow: '0 2px 6px rgba(0,0,0,0.18)',
      whiteSpace: 'nowrap',
      maxWidth: 160,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      pointerEvents: 'none',
      zIndex: 2,
    },
  };

  return (
    <span style={styles.pill}>
      <Icon size={10} strokeWidth={2.5} />
      {label}
    </span>
  );
};

export default MessageRolePill;
